import { baseApi } from '@app/store/index.api';

import { ICreateWalletTagQuery, ICreateWalletTagResponse, IWalletTagsResponse } from '../model/types';

const walletTagsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getWalletTags: builder.query<IWalletTagsResponse, void>({
      query: () => ({
        url: '/wallet-tags',
      }),
      providesTags: ['WalletTags'],
    }),
    createWalletTag: builder.mutation<ICreateWalletTagResponse, ICreateWalletTagQuery>({
      query: body => ({
        url: '/wallet-tags',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['WalletTags'],
    }),
  }),
});

export const { useGetWalletTagsQuery, useCreateWalletTagMutation } = walletTagsApi;
